module.exports = __webpack_public_path__ + "static/media/single.a633606b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/single.png
// module id = 412
// module chunks = 0